import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Modal, Popconfirm, Space, Table, Tooltip } from "antd";
import { useEffect, useState } from "react";
import Sidebar from "../../../Sidebar";
import DoctorHeader from "../../../../doctor/DoctorHeader";
import { useDelete } from "../../../../hooks/apiHooks";
import apiClient from "../../../../utils/apiClient";
import useToast from "../../../../hooks/userToast";
import MasterAdd from "./MasterAdd";
import MasterEdit from "./MasterEdit";
import PropTypes from "prop-types";
import { plusicon } from "../../../imagepath";

MasterTable.propTypes = {
  endpoint: PropTypes.string,
  name: PropTypes.string,
  modalName: PropTypes.string,
};

function MasterTable({ endpoint, name, modalName }) {
  console.log(endpoint, modalName, name);

  // console.log("name", name);
  const [addModalState, setAddModalState] = useState({ isModalOpen: false });
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [editModalState, setEditModalState] = useState({
    isModalOpen: false,
    id: null,
    name: "",
    description: "",
  });
  const { delLoading } = useDelete();
  const { toastError, toastSuccess } = useToast();
  const [data, setData] = useState();
  const getData = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get(
        `${endpoint}?page=${currentPage}&limit=${limit}`
      );
      const filterSection = endpoint.replace("/", "");
      setData(response.data[filterSection]);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getData();
  }, [currentPage, limit]);
  const refetch = () => {
    setCurrentPage(1);
    setLimit(10);
    getData();
  };

  const showAddModal = () => {
    setAddModalState({ isModalOpen: true });
  };

  const showEditModal = (id, name, description) => {
    setEditModalState(() => {
      return {
        id,
        name,
        description,
        isModalOpen: true,
      };
    });
  };

  const handleOk = () => {
    setAddModalState({ isModalOpen: false });
  };

  const handleEditOk = () => {
    setEditModalState(() => {
      return {
        isModalOpen: false,
        id: "",
        name: "",
        description: "",
      };
    });
  };

  const handleCancel = () => {
    setAddModalState({ isModalOpen: false });
  };

  const handleEditCancel = () => {
    setEditModalState(() => {
      return {
        isModalOpen: false,
        id: "",
        name: "",
        description: "",
      };
    });
  };

  const handleDelete = (id) => {
    apiClient
      .delete(`${endpoint}/${id}`)
      .then(() => {
        refetch(); // Refetch the data after successful delete
        toastSuccess("Deleted Successfully!");
      })
      .catch((err) => {
        console.error("Delete failed", err);
        toastError(err?.response?.data?.error);
      });
  };

  // useEffect(() => {
  //   function checkPagination() {
  //     SetIsPagination(
  //       name === "Grades" || name === "Quality" || name === "Priority"
  //         ? false
  //         : true
  //     );
  //   }
  //   checkPagination();
  // }, [name]);

  const columns = [
    {
      title: name,
      dataIndex: "name",
      key: "name",
      align: "center",
      width: 200,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      align: "center",
      width: 300,

      render: (text) => (
        <div
          style={{
            whiteSpace: "normal",
            textWrap: "wrap",
            textAlign: "center",
            // width: "500px",
            overflowWrap: "break-word !important",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      width: 100,
      render: (text, record) => (
        <Space style={{ padding: "5px" }}>
          <Tooltip title="Edit">
            <Button
              onClick={() => {
                showEditModal(record.id, record.name, record.description);
              }}
            >
              <EditOutlined />
            </Button>
          </Tooltip>
          <Tooltip title="Delete">
            <Popconfirm
              title="Are you sure you want to delete?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => handleDelete(record.id)} // Pass the delete function to onConfirm
            >
              <Button>
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
      align: "center",
    },
  ];

  if (delLoading) {
    return;
  }

  return (
    <>
      <DoctorHeader />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body cus_box">
                  {/* Table Header */}
                  <div className="page-table-header mb-2">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h2>{name}</h2>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk"></div>
                            <div className="add-group">
                              {/* <Button
                  className="add_on_button"
                  style={{
                    background: "#016FB9",
                    color: "white",
                    fontSize: "14px",
                  }}
                  type="primary"
                  onClick={showAddModal}
                >
                  Add
                </Button> */}
                              <div className="add-group">
                                <Tooltip title={` Add ${modalName}`}>
                                  <Button
                                    onClick={() => showAddModal()}
                                    className="btn btn-primary add-pluss addone_plus ms-2"
                                  >
                                    <img src={plusicon} alt="#" />
                                  </Button>
                                </Tooltip>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Table Header */}
                  <div className="tablemain_auto doctor-list">
                    <Table
                    className="gradetable_table_border"
                      columns={columns}
                      dataSource={data?.data}
                      rowKey={(record) => record.id}
                      scroll={{ x: 800 }}
                      bordered
                      loading={loading}
                      pagination={{
                        total: data?.total,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        onChange: (page) => {
                          setCurrentPage(page);
                        },
                        showSizeChanger: true,
                        onShowSizeChange: (current, size) => setLimit(size),
                        showQuickJumper: true,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        title={`Add ${modalName}`}
        className="ModalFooterHide"
        open={addModalState.isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        maskClosable={false}
        destroyOnClose
      >
        <MasterAdd
          name={name}
          fetchData={refetch}
          handleOk={handleOk}
          Addurl={endpoint}
        />
      </Modal>

      <Modal
        className="ModalFooterHide"
        title={`Edit ${modalName}`}
        open={editModalState.isModalOpen}
        onOk={handleEditOk}
        onCancel={handleEditCancel}
        handleOk={handleEditOk}
        maskClosable={false}
        destroyOnClose
      >
        <MasterEdit
          fetchData={refetch}
          id={editModalState.id}
          name={editModalState.name}
          description={editModalState.description}
          type="edit"
          handleOk={handleEditOk}
          Editurl={endpoint}
        />
      </Modal>
    </>
  );
}

export default MasterTable;
